import { render, staticRenderFns } from "./ConversionesDisponibles.vue?vue&type=template&id=48132f25&scoped=true"
import script from "./ConversionesDisponibles.vue?vue&type=script&lang=js"
export * from "./ConversionesDisponibles.vue?vue&type=script&lang=js"
import style0 from "./ConversionesDisponibles.vue?vue&type=style&index=0&id=48132f25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48132f25",
  null
  
)

export default component.exports